export const RelatedClientsPermissions = {
  default: 'User.RiskMonitoring.RelatedClients',
  ipTab: 'User.RiskMonitoring.RelatedClients.RelatedClientsIp',
  deviceTab: 'User.RiskMonitoring.RelatedClients.RelatedClientsDevice',
} as const;
